import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    const openIds = this.openMenuIds()

    this.menuTargets.forEach((menu) => {
      if (openIds.includes(menu.id)) {
        menu.classList.add("show")

        const toggle = this.element.querySelector(`[data-bs-target="#${menu.id}"]`)
        if (toggle) {
          toggle.classList.remove("collapsed")
          toggle.setAttribute("aria-expanded", "true")
        }
      }
    })

    this.menuTargets.forEach((menu) => {
      menu.addEventListener("shown.bs.collapse", () => this.saveState())
      menu.addEventListener("hidden.bs.collapse", () => this.saveState())
    })
  }

  openMenuIds() {
    const match = document.cookie.match(/(?:^|;\s*)open_practitioner_menus=([^;]*)/)
    if (!match) return []

    try {
      return JSON.parse(decodeURIComponent(match[1]))
    } catch {
      return []
    }
  }

  saveState() {
    const openIds = this.menuTargets
      .filter((menu) => menu.classList.contains("show"))
      .map((menu) => menu.id)

    document.cookie = `open_practitioner_menus=${encodeURIComponent(JSON.stringify(openIds))};path=/;max-age=31536000;SameSite=Lax`
  }
}
